export const SET_VISIBLE_EXPENSES = 'SET_VISIBLE_EXPENSES';
export const SELECT_EXPENSE = 'SELECT_EXPENSE';
export const UNSELECT_EXPENSE = 'UNSELECT_EXPENSE';
export const SELECT_ALL_EXPENSES = 'SELECT_ALL_EXPENSES';
export const UNSELECT_ALL_EXPENSES = 'UNSELECT_ALL_EXPENSES';
export const CHECK_EXPENSE = 'CHECK_EXPENSE';
export const UNCHECK_EXPENSE = 'UNCHECK_EXPENSE';
export const CHECK_ALL_EXPENSES = 'CHECK_ALL_EXPENSES';
export const UNCHECK_ALL_EXPENSES = 'UNCHECK_ALL_EXPENSES';
export const RECEIVE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS';
export const ACTIVATE_FILTER = 'ACTIVATE_FILTER';
export const ACTIVATE_FILTERS = 'ACTIVATE_FILTERS';
export const DEACTIVATE_FILTER = 'DEACTIVATE_FILTER';
export const DEACTIVATE_AMOUNT_FILTERS = 'DEACTIVATE_AMOUNT_FILTERS';
export const DEACTIVATE_ALL_FILTERS = 'DEACTIVATE_ALL_FILTERS';
export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const OPEN_DATE_RANGE_FILTER = 'OPEN_DATE_RANGE_FILTER';
export const CLOSE_DATE_RANGE_FILTER = 'CLOSE_DATE_RANGE_FILTER';
export const SET_SEARCH_VIEW = 'SET_SEARCH_VIEW';
export const INCREMENT_REQUEST_COUNT = 'INCREMENT_REQUEST_COUNT';
export const DECREMENT_REQUEST_COUNT = 'DECREMENT_REQUEST_COUNT';
export const SELECT_SAVED_SEARCH = 'SELECT_SAVED_SEARCH';
export class SetVisibleExpenses {
    constructor(expenseIds) {
        this.expenseIds = expenseIds;
        this.type = SET_VISIBLE_EXPENSES;
    }
}
export class SelectExpense {
    constructor(expenseId) {
        this.expenseId = expenseId;
        this.type = SELECT_EXPENSE;
    }
}
export class UnselectExpense {
    constructor() {
        this.type = UNSELECT_EXPENSE;
    }
}
export class CheckExpense {
    constructor(expenseId) {
        this.expenseId = expenseId;
        this.type = CHECK_EXPENSE;
    }
}
export class UncheckExpense {
    constructor(expenseId) {
        this.expenseId = expenseId;
        this.type = UNCHECK_EXPENSE;
    }
}
export class CheckAllExpenses {
    constructor(expenseIds) {
        this.expenseIds = expenseIds;
        this.type = CHECK_ALL_EXPENSES;
    }
}
export class UncheckAllExpenses {
    constructor() {
        this.type = UNCHECK_ALL_EXPENSES;
    }
}
export class ReceiveSearchResults {
    constructor(results) {
        this.results = results;
        this.type = RECEIVE_SEARCH_RESULTS;
    }
}
export class SelectAllExpenses {
    constructor() {
        this.type = SELECT_ALL_EXPENSES;
    }
}
export class UnselectAllExpenses {
    constructor() {
        this.type = UNSELECT_ALL_EXPENSES;
    }
}
export class ActivateFilter {
    constructor(filterName, value, filterType = 'general') {
        this.filterName = filterName;
        this.value = value;
        this.filterType = filterType;
        this.type = ACTIVATE_FILTER;
    }
}
export class ActivateFilters {
    constructor(filters) {
        this.filters = filters;
        this.type = ACTIVATE_FILTERS;
    } // for saved searches really
}
export class DeactivateFilter {
    constructor(filterName, value, filterType = 'general') {
        this.filterName = filterName;
        this.value = value;
        this.filterType = filterType;
        this.type = DEACTIVATE_FILTER;
    }
}
export class DeactivateAmountFilters {
    constructor() {
        this.type = DEACTIVATE_AMOUNT_FILTERS;
    }
}
export class DeactivateAllFilters {
    constructor() {
        this.type = DEACTIVATE_ALL_FILTERS;
    }
}
export class OpenMenu {
    constructor() {
        this.type = OPEN_MENU;
    }
}
export class CloseMenu {
    constructor() {
        this.type = CLOSE_MENU;
    }
}
export class OpenDateRangeFilter {
    constructor() {
        this.type = OPEN_DATE_RANGE_FILTER;
    }
}
export class CloseDateRangeFilter {
    constructor() {
        this.type = CLOSE_DATE_RANGE_FILTER;
    }
}
export class SetSearchView {
    constructor(view) {
        this.view = view;
        this.type = SET_SEARCH_VIEW;
    }
}
export class IncrementRequestCount {
    constructor() {
        this.type = INCREMENT_REQUEST_COUNT;
    }
}
export class DecrementRequestCount {
    constructor() {
        this.type = DECREMENT_REQUEST_COUNT;
    }
}
export class SelectSavedSearch {
    constructor(savedSearch) {
        this.savedSearch = savedSearch;
        this.type = SELECT_SAVED_SEARCH;
    }
}
